<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><span aria-label="ii" class="page" id="pii" role="doc-pagebreak"></span><span aria-label="iii" class="page" id="piii" role="doc-pagebreak"></span>CAPITALISM AND FREEDOM</h1>
<h1 class="bk1">With a New Foreword by Binyamin Appelbaum</h1>
<p class="bkau">MILTON FRIEDMAN</p>
<p class="bkau1">With the Assistance of Rose D. Friedman</p>
<p class="bkpub">THE UNIVERSITY OF CHICAGO PRESS | CHICAGO AND LONDON</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-friedman-capitalism-0003.vue?4a084ed8